<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/printConfig/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('yewubianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mobanmingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('danjuleixing')">
            <yi_dictionary_select clearable="false" :type="'PRINT_DOCUMENT_TYPE'" :ids.sync="yt.conditions.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ type: $attrs.type, status: $attrs.status })">{{ $t('chongzhi') }} </el-button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          v-if="utils.checkPower('web_base_print_create')"
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, 'w1');
            yt.editObj.isDefault = 1;
            yt.editObj.status = 1;
          "
          type="primary"
        >
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!-- <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="yt.exportExcel()"></el-button>
				</el-button> -->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <!-- 自定义某个字段 -->
      <!-- 角色 -->
      <template #juese="scope">
        <template>
          <span>{{ scope.row.roleObjects | getRoleText }}</span>
          <!-- <span v-if="scope.row.roleObjects">{{scope.row.roleObjects | getRoleText}}</span>
					<span v-else>{{(scope.row.roleObjects | getRoleText) || ''}}</span> -->
        </template>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_base_print_edit')" type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1')">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_base_print_delete')" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/printConfig/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 底部插槽 -->
      <template #footer> </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body>
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('yewubianma')" required>
            <el-input v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mobanmingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('danjuleixing')" required>
            <yi_dictionary_select clearable="false" :type="'PRINT_DOCUMENT_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shifoumoren')" required>
            <el-select v-model="yt.editObj.isDefault">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shifoushiyong')" required>
            <el-select v-model="yt.editObj.status">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
          <el-form-item :label="$t('peizhimoban')" v-show="yt.editObj.type != null">
            <a
              style="color:#419fff"
              @click="
                currentPrint = yt.editObj;
                isShowConfigDialog = true;
              "
              >{{ $t('peizhimoban') }}</a
            >
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/printConfig/create', beforeCreate)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('yewubianma')" required>
            <el-input v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mobanmingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('danjuleixing')" required>
            <yi_dictionary_select :disabled="true" clearable="false" :type="'PRINT_DOCUMENT_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shifoumoren')" required>
            <el-select v-model="yt.editObj.isDefault">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shifoushiyong')" required>
            <el-select v-model="yt.editObj.status">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
          <el-form-item :label="$t('peizhimoban')">
            <a
              style="color:#419fff"
              @click="
                currentPrint = yt.editObj;
                isShowConfigDialog = true;
              "
              >{{ $t('peizhimoban') }}</a
            >
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/printConfig/update', beforeCreate)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog :show-close="true" :title="$t('peizhimoban')" :visible.sync="isShowConfigDialog" :width="'80%'" :close-on-click-modal="false" append-to-body :destroy-on-close="true">
      <div class="dialog-scroller" v-if="isShowConfigDialog">
        <template_purchase_in v-if="yt.editObj.type == 0" ref="templat" :config="yt.editObj.config"></template_purchase_in>
        <template_without_in v-if="yt.editObj.type == 1" ref="templat" :config="yt.editObj.config"></template_without_in>
        <template_deliver_out v-if="yt.editObj.type == 2" ref="templat" :config="yt.editObj.config"></template_deliver_out>
        <template_without_out v-if="yt.editObj.type == 3" ref="templat" :config="yt.editObj.config"></template_without_out>
        <template_product_in v-if="yt.editObj.type == 4" ref="templat" :config="yt.editObj.config"></template_product_in>
        <template_product_out v-if="yt.editObj.type == 5" ref="templat" :config="yt.editObj.config"></template_product_out>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowConfigDialog = false">{{ $t('quxiao') }}</el-button>
        <el-button
          :loading="yt.editObj.loading"
          size="mini"
          @click="
            yt.editObj.config = JSON.stringify($refs.templat.printTem);
            isShowConfigDialog = false;
          "
          type="primary"
        >
          {{ $t('baocun') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import template_purchase_in from '@@/pages/web/base/print/template_purchase_in';
import template_without_in from '@@/pages/web/base/print/template_without_in';
import template_deliver_out from '@@/pages/web/base/print/template_deliver_out';
import template_without_out from '@@/pages/web/base/print/template_without_out';
import template_product_in from '@@/pages/web/base/print/template_product_in';
import template_product_out from '@@/pages/web/base/print/template_product_out';

export default {
  name: 'web_base_print_list',
  components: {
    template_purchase_in,
    template_without_in,
    template_deliver_out,
    template_without_out,
    template_product_in,
    template_product_out
  },

  data() {
    return {
      isShowConfigDialog: false,
      currentPrint: {},
      columns: [
        {
          label: 'yewubianma',
          prop: 'code',
          width: 150
        },
        {
          label: 'danjuleixing',
          prop: 'type',
          type: 'dictionary',
          key: 'PRINT_DOCUMENT_TYPE'
        },
        {
          label: 'mobanmingcheng',
          prop: 'name'
        },
        {
          label: 'shifoumoren',
          prop: 'isDefault',
          type: 'bool',
          iln18: ['shi', 'fou']
        },
        {
          label: 'shifoushiyong',
          prop: 'status',
          type: 'bool',
          iln18: ['shi', 'fou']
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 180,
          fixed: 'right'
        }
      ]
    };
  },

  created() {
    setTimeout(() => {
      this.yt.SELECT_URL = '/web/equipment/standing_book/getEquipmentByIds'; //临时用
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'name';

      console.log(this.$attrs);

      if (this.$attrs.type != null) {
        this.yt.conditions.type = this.$attrs.type;
      }
      if (this.$attrs.status != null) {
        this.yt.conditions.status = this.$attrs.status;
      }
      this.yt.get(1);
    }, 300);
  },

  methods: {
    // updateConfig(editObj) {
    // 	this.http.post('/web/system/auth/user/resetPwd', {
    // 		id: editObj.id,
    // 	}).then((res) => {
    // 		this.utils.successMessage(this.$t(res.msg));
    // 	}).catch((msg) => {
    // 		this.utils.errorMessage(msg);
    // 	})
    // },
  }
};
</script>
